/* eslint-disable arrow-parens */
/* eslint-disable implicit-arrow-linebreak */
import { createSelector } from 'reselect'
import { initialState } from './reducer'

const selectTaskManagement = (state) => state.taskManagementStore || initialState

export const makeSelectTaskCategories = () =>
  createSelector(
    selectTaskManagement,
    (state) => state.taskCategories
  )

export const makeSelectTaskUserList = () =>
  createSelector(
    selectTaskManagement,
    (state) => state.taskUserList
  )

export const makeSelectTasks = () =>
  createSelector(
    selectTaskManagement,
    (state) => state.tasks
  )

export const makeSelectUnreadTasks = () =>
  createSelector(
    selectTaskManagement,
    (state) => state.unreadTasks
  )

export const makeSelectStatusFilter = () =>
  createSelector(
    selectTaskManagement,
    (state) => state.statusFIlter
  )
